<template>
  <div class="home">
    <BannerForm
      @concluido="cidadeCarroSelecionada"
      @retrocede_etapa="retrocedeEtapa"
    />
    <molBaterias
      v-if="etapa >= 2"
      :baterias="this.baterias"
      :parcelas="this.parcelas"
      @selected="bateriaEscolhida"
    />
    <!-- <pedidoForm v-if="etapa >= 3" :temCupom="this.temCupom" :cidade="this.cidade.split('-')[0].trim()" :uf="this.cidade.split('-')[1].trim()" :carro="this.carro" :bateria="this.bateriaSelecionada" :parcelasDisp="this.parcelas" :bandeiras="this.bandeiras" :dataAtual="this.dataAtual" :horario="this.horario" :feriados="this.feriados"/> -->
    <Beneficios v-if="etapa == 1" />
    <orgDescricao />
    <comoFunciona v-if="etapa == 1" />
    <molCarrosselMontadoras />
    <ModalTermos />
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Beneficios from "@/components/MolBeneficios.vue";
import orgDescricao from "@/components/OrgDescricao.vue";
import MolCarrosselMontadoras from "@/components/MolCarrosselMontadoras.vue";
import molBaterias from "@/components/MolBaterias.vue";
// import pedidoForm from '@/components/PedidoForm.vue'
import ModalTermos from "@/components/ModalTermos.vue";
import BannerForm from "@/components/BannerForm.vue";
import comoFunciona from "../components/ComoFunciona.vue";
export default {
  name: "home",
  components: {
    Beneficios,
    orgDescricao,
    MolCarrosselMontadoras,
    molBaterias,
    // pedidoForm,
    ModalTermos,
    BannerForm,
    comoFunciona,
  },
  data() {
    return {
      etapa: 1,
      cidade: "",
      carro: "",
      temCupom: "",
      dataAtual: "",
      baterias: [],
      bandeiras: [],
      etapaAtual: 1,
      bateriaSelecionada: {},
      parcelas: 0,
      horario: [],
      feriados: [],
    };
  },
  props: {
    cidadeCarro: Array,
  },
  watch: {
    cidadeCarro: function(novaLista) {
      if (novaLista.length == 0) {
        this.etapa = 1;
        this.bateriaSelecionada = {};
        this.cidade = "";
        this.carro = "";
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: 0,
          },
          500
        );
      } else {
        this.cidadeCarroSelecionada();
        this.etapa = 2;
      }
    },
  },
  methods: {
    bateriaEscolhida(bateria) {
      this.bateriaSelecionada = bateria;
      this.etapa = 3;
      setTimeout(() => {
        var scroll = $(".pedido-form").offset().top;
        //var headerSize = $(".header").height();
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: scroll,
          },
          500
        );
      });
    },
    cidadeCarroSelecionada(cidadeCarro) {
      if (cidadeCarro.length == 0) {
        this.etapa = 1;
        this.bateriaSelecionada = {};
        this.cidade = "";
        this.carro = "";
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: 0,
          },
          500
        );
      } else {
        this.cidade = cidadeCarro[0];
        this.carro = cidadeCarro[1];
        this.etapa = 2;
      }
      this.bateriaSelecionada = {};
      $.ajax({
        // url: process.env.NODE_ENV=='production'?'./api/SegundaEtapa?carro=' + encodeURIComponent(this.carro) + '&cidadeEstado=' + encodeURIComponent(this.cidade):'http://testeheliarexpress.servicos.ws/api/SegundaEtapa?carro=' + encodeURIComponent(this.carro) + '&cidadeEstado=' + encodeURIComponent(this.cidade),
        url:
          process.env.NODE_ENV == "production"
            ? "./api/SegundaEtapa?carro=" +
              encodeURIComponent(this.carro) +
              "&cidadeEstado=" +
              encodeURIComponent(this.cidade)
            : "https://www2.heliarexpress.com.br/api/SegundaEtapa?carro=" +
              encodeURIComponent(this.carro) +
              "&cidadeEstado=" +
              encodeURIComponent(this.cidade),
        type: "GET",
        success: (response) => {
          if (response.Success == false) {
            sessionStorage.setItem("cidade", "");
            sessionStorage.setItem("carro", "");
          } else {
            this.dataAtual = new Date(
              response.data.slice(0, response.data.length - 6)
            );
            setInterval(() => {
              var data = new Date(this.dataAtual.toISOString());
              data.setSeconds(data.getSeconds() + 10);
              this.dataAtual = new Date(data.toISOString());
            }, 10000);
            this.temCupom = response.cupom;
            this.bandeiras = response.bandeiras;
            this.baterias = response.baterias;
            if (this.baterias.length == 0) {
              window.swal
                .fire({
                  title: "Ops",
                  text:
                    "Não foram encontradas baterias para o seu carro na cidade escolhida.",
                  icon: "warning",
                  iconColor: "#1ED760",
                  color: "#3C3C3B",
                  confirmButtonColor: "#1ED760",
                  background: "#EDEDED",
                  confirmButtonText: "Ok",
                })
                .then(() => {
                  sessionStorage.setItem("cidade", "");
                  sessionStorage.setItem("carro", "");
                });
            }
            this.parcelas = response.parcelas;
            this.horario[0] = response.atendimento[6];
            this.horario[1] = response.atendimento[0];
            this.horario[2] = response.atendimento[1];
            this.horario[3] = response.atendimento[2];
            this.horario[4] = response.atendimento[3];
            this.horario[5] = response.atendimento[4];
            this.horario[6] = response.atendimento[5];
            this.feriados = response.feriado;
            setTimeout(() => {
              var scroll = $(".baterias-wrapper").offset().top;
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: scroll,
                },
                500
              );
            });
          }
        },
        error: () => {
          swal
            .fire({
              title: "Ops",
              text: "Algo deu errado e a página será atualizada",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            })
            .then(() => {
              sessionStorage.setItem("cidade", "");
              sessionStorage.setItem("carro", "");
              window.location.reload();
              // this.$router.push({name:"home"});
            });
        },
      });
    },
    retrocedeEtapa() {
      this.etapa = 1;
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: 0,
        },
        500
      );
    },
    scrollTopo() {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: 0,
        },
        500
      );
    },
  },
};
</script>
